const deliveryServiceTypes = Object.freeze({
  bevz: { capitalize: "BEVZ", cammel: "bevz" },
  doordash: { capitalize: "DOORDASH", cammel: "doordash", capitalFirst: "Doordash" },
  grubhub: { capitalize: "GRUBHUB", cammel: "grubhub", capitalFirst: "Grubhub" },
  uberEats: { capitalize: "UBEREATS", cammel: "uberEats", capitalFirst: "UberEats" },
});

export default deliveryServiceTypes;

// DOORDASH | UBEREATS | GRUBHUB | BEVZ
// bevz | doordash | grubhub | uberEats
